/* ============================================================
   LA FLAMA ALQUILER — Rental Cart Logic
   ============================================================ */

(function () {
  'use strict';

  const STORAGE_KEY = 'laflama_alquiler_cart';
  const SESSION_KEY = 'laflama_alquiler_session';
  const MAX_DISCS = 3;

  function getCart() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch { return []; }
  }

  function saveCart(cart) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
    window.dispatchEvent(new CustomEvent('alquiler:updated', { detail: { cart } }));
  }

  function addToCart(disc) {
    const cart = getCart();
    if (cart.length >= MAX_DISCS) return false;
    if (cart.some(d => d.id === disc.id)) return false;
    cart.push(disc);
    saveCart(cart);
    return true;
  }

  function removeFromCart(discId) {
    saveCart(getCart().filter(d => d.id !== discId));
  }

  function clearCart() { saveCart([]); }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function updateHeaderBadge() {
    const cart = getCart();
    const badge = document.getElementById('alquiler-header-badge');
    if (!badge) return;
    badge.textContent = cart.length;
    badge.style.display = cart.length > 0 ? 'flex' : 'none';
  }

  function openDrawer() {
    document.getElementById('alquiler-drawer')?.classList.add('open');
    document.getElementById('alquiler-drawer-overlay')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderDrawerItems();
  }

  function closeDrawer() {
    document.getElementById('alquiler-drawer')?.classList.remove('open');
    document.getElementById('alquiler-drawer-overlay')?.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderDrawerItems() {
    const cart = getCart();
    const body = document.getElementById('alquiler-drawer-body');
    const footer = document.getElementById('alquiler-drawer-footer');
    const counter = document.getElementById('alquiler-drawer-counter');
    if (!body) return;

    if (counter) counter.textContent = '(' + cart.length + '/' + MAX_DISCS + ')';

    if (cart.length === 0) {
      body.innerHTML = '<p class="alquiler-drawer__empty">Tu cesta de alquiler est\u00e1 vac\u00eda.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = 'block';

    let total = 0;
    let html = '';
    cart.forEach(function(disc) {
      total += disc.price;
      html += '<div class="alquiler-drawer__item">' +
        '<img class="alquiler-drawer__item-img" src="' + disc.image + '" alt="' + disc.title + '" loading="lazy">' +
        '<div class="alquiler-drawer__item-info">' +
        '<p class="alquiler-drawer__item-title">' + disc.title + '</p>' +
        '<p class="alquiler-drawer__item-price">Fianza: ' + formatMoney(disc.price) + '</p>' +
        '</div>' +
        '<button class="alquiler-drawer__item-remove" data-id="' + disc.id + '" aria-label="Quitar">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button></div>';
    });

    body.innerHTML = html;
    const totalEl = document.getElementById('alquiler-drawer-total');
    if (totalEl) totalEl.textContent = formatMoney(total);

    body.querySelectorAll('.alquiler-drawer__item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        removeFromCart(btn.dataset.id);
        renderDrawerItems();
        updateHeaderBadge();
        updateProductButtons();
      });
    });
  }

  function updateProductButtons() {
    const cart = getCart();
    const cartIds = cart.map(function(d) { return d.id; });
    document.querySelectorAll('[data-alquiler-btn]').forEach(function(btn) {
      const productId = btn.dataset.alquilerId;
      const alreadyIn = cartIds.includes(productId);
      const full = cart.length >= MAX_DISCS && !alreadyIn;
      if (alreadyIn) {
        btn.textContent = '\u2713 Ya en tu solicitud de alquiler';
        btn.disabled = true;
      } else if (full) {
        btn.textContent = 'L\u00edmite alcanzado (3/3)';
        btn.disabled = true;
      } else {
        btn.textContent = '\ud83e\udd4f Solicitar alquiler';
        btn.disabled = false;
      }
    });
  }

  function openModal() {
    closeDrawer();
    const overlay = document.getElementById('alquiler-modal-overlay');
    if (!overlay) return;
    renderModal();
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    document.getElementById('alquiler-modal-overlay')?.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderModal() {
    const cart = getCart();
    const overlay = document.getElementById('alquiler-modal-overlay');
    if (!overlay) return;
    const termsText = overlay.dataset.terms || 'Condiciones del alquiler:\n\n1. Se cobra el 100% del PVP como fianza.\n2. Se devuelve el 75% por disco devuelto en buen estado.\n3. Entrega y recogida coordinadas por email.\n4. Periodo de revisi\u00f3n de 48h tras devoluci\u00f3n.\n5. M\u00e1ximo 3 discos por solicitud.';
    const modal = overlay.querySelector('.alquiler-modal');
    if (!modal) return;

    let total = 0;
    let discsHtml = '';
    cart.forEach(function(disc) {
      total += disc.price;
      discsHtml += '<div class="alquiler-modal__disc-item"><span>' + disc.title + '</span><span class="alquiler-modal__disc-price">' + formatMoney(disc.price) + '</span></div>';
    });

    modal.innerHTML =
      '<h2 class="alquiler-modal__title">Solicitar alquiler</h2>' +
      '<div class="alquiler-modal__discs">' + discsHtml +
      '<div class="alquiler-modal__total"><span>Fianza total (100% PVP)</span><span>' + formatMoney(total) + '</span></div></div>' +
      '<p class="alquiler-modal__label" style="margin-bottom:6px;">Condiciones del alquiler</p>' +
      '<div class="alquiler-modal__terms">' + termsText + '</div>' +
      '<div class="alquiler-modal__check-row"><input type="checkbox" id="alq-terms"><label class="alquiler-modal__check-label" for="alq-terms">He le\u00eddo y acepto las condiciones del alquiler</label></div>' +
      '<div id="alq-error" class="alquiler-modal__error" style="display:none;"></div>' +
      '<div class="alquiler-modal__actions"><button class="alquiler-modal__cancel" id="alq-cancel">Cancelar</button><button class="alquiler-modal__submit" id="alq-submit">Continuar</button></div>';

    document.getElementById('alq-cancel')?.addEventListener('click', closeModal);

    document.getElementById('alq-submit')?.addEventListener('click', function() {
      const terms = document.getElementById('alq-terms').checked;
      const errorEl = document.getElementById('alq-error');

      if (!terms) {
        errorEl.textContent = 'Debes aceptar las condiciones del alquiler.';
        errorEl.style.display = 'block';
        return;
      }

      // Guardar datos en sessionStorage y redirigir
      const sessionData = {
        cart: cart,
        total: total,
        timestamp: Date.now()
      };
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
      window.location.href = '/pages/alquiler-form';
    });
  }

  function init() {
    document.getElementById('alquiler-header-btn')?.addEventListener('click', openDrawer);
    document.getElementById('alquiler-drawer-overlay')?.addEventListener('click', closeDrawer);
    document.getElementById('alquiler-drawer-close')?.addEventListener('click', closeDrawer);
    document.getElementById('alquiler-drawer-cta')?.addEventListener('click', openModal);
    document.getElementById('alquiler-modal-overlay')?.addEventListener('click', function(e) {
      if (e.target === e.currentTarget) closeModal();
    });

    document.querySelectorAll('[data-alquiler-btn]').forEach(function(btn) {
      var form = btn.closest('form') || document.querySelector('form[action="/cart/add"]');
      var variantInput = form ? form.querySelector('input[name="id"]') : null;

      if (variantInput && variantInput.value) {
        fetch('/variants/' + variantInput.value + '.js')
          .then(function(r) { return r.json(); })
          .then(function(variant) {
            btn.dataset.alquilerPrice = variant.price;
            btn.dataset.alquilerVariantId = variantInput.value;
            var variantTitle = (variant.title && variant.title !== 'Default Title') ? ' \u2014 ' + variant.title : '';
            if (!variant.available) {
              btn.textContent = 'Sin stock para alquiler';
              btn.disabled = true;
              btn.style.opacity = '0.5';
              btn.style.cursor = 'not-allowed';
            } else {
              btn.textContent = 'Solicitar alquiler' + variantTitle;
            }
            if (variant.featured_image && variant.featured_image.src) {
              btn.dataset.alquilerImage = variant.featured_image.src;
            }
          });
      }

      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        var currentTitle = btn.dataset.alquilerTitle || btn.textContent.trim();
        var added = addToCart({
          id: btn.dataset.alquilerId,
          title: currentTitle,
          price: parseInt(btn.dataset.alquilerPrice, 10),
          image: btn.dataset.alquilerImage,
          url: btn.dataset.alquilerUrl,
          variantId: btn.dataset.alquilerVariantId
        });
        if (added) { updateHeaderBadge(); updateProductButtons(); openDrawer(); }
      });

      if (!variantInput) return;
      var lastVariantId = variantInput.value;

      var observer = new MutationObserver(function() {
        var variantId = variantInput.value;
        if (variantId === lastVariantId) return;
        lastVariantId = variantId;

        fetch('/variants/' + variantId + '.js')
          .then(function(r) { return r.json(); })
          .then(function(variant) {
            btn.dataset.alquilerPrice = variant.price;
            btn.dataset.alquilerVariantId = variantId;
            var variantTitle = (variant.title && variant.title !== 'Default Title') ? ' \u2014 ' + variant.title : '';
            var cart = getCart();
            var alreadyIn = cart.some(function(d) { return d.id === btn.dataset.alquilerId; });

            if (!variant.available) {
              btn.textContent = 'Sin stock para alquiler';
              btn.disabled = true;
              btn.style.opacity = '0.5';
              btn.style.cursor = 'not-allowed';
            } else if (!alreadyIn && cart.length < MAX_DISCS) {
              btn.textContent = 'Solicitar alquiler' + variantTitle;
              btn.disabled = false;
              btn.style.opacity = '';
              btn.style.cursor = '';
            }

            if (variant.featured_image && variant.featured_image.src) {
              btn.dataset.alquilerImage = variant.featured_image.src;
            }
          });
      });

      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    });

    window.addEventListener('alquiler:updated', function() {
      updateHeaderBadge(); updateProductButtons();
    });

    updateHeaderBadge();
    updateProductButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
